// require('object-fit-images');
import objectFitImages from 'object-fit-images';
import SVGInjector from 'svg-injector';
import Clipboard from 'clipboard';
import Flickity from 'flickity';
var mixitup = require('mixitup');

import Cookies from 'js-cookie';


(function($) {
	var Starter = {
		// All pages
		'common': {

		  	init: function() {

		  		viewportWidth   = $(window).width();
        	    viewportHeight	= $(window).height();


        	    objectFitImages('img.img--objectfit');



				// Popup
				const popup = document.querySelector('[data-popup]');
				const popupCloseBtn = document.querySelector('[data-btn-close-popup]');
				const cookie = Cookies.get('popup_closed');

				if (cookie == null) {
					setTimeout(() => {
						popup.classList.add('show');
					}, 5000);
				}

				popupCloseBtn.addEventListener('click', () => {
					Cookies.set('popup_closed', 'seen', { expires: 7 });
					popup.classList.remove('show');
				});

				$(document).on('gform_confirmation_loaded', function(event, formId){
					if(formId == 1) {
						Cookies.set('popup_closed', 'seen', { expires: 7 });
						popup.classList.remove('show');
					}
					else if(formId == 2) {
						Cookies.set('popup_closed', 'seen', { expires: 7 });
						popup.classList.add('form-sent');
					}
					else if(formId == 3) {
						const downloadForm = document.querySelector('[data-download]');
						downloadForm.classList.add('form-sent');
					}
				});
				// //


				// Submenu op mobiel
				$(".menu-mobile")
					.find(".menu-item-has-children")
					.find("a:first")
					.on("click", function(e) {
						e.preventDefault();

						$(this)
						.closest(".menu-item-has-children")
						.find(".sub-menu")
						.addClass("sub-menu--active");
					});

				$(".menu-mobile")
					.find(".btn-prev")
					.on("click", function(e) {
					// e.preventDefault();
						$(this)
						  .closest(".sub-menu")
						  .removeClass("sub-menu--active");

						e.stopPropagation();
					});

				$('.nav__hamburger').click(function(){
					// toggleMenu();
					$('.nav__menu-collapse').toggleClass('toggle');
					$(this).toggleClass('is-active');
				});

				$(window).on('load', function(){
					$('.block--header').addClass('block--header--loaded');

					var winHeight = (typeof window.outerHeight != 'undefined')?Math.max(window.outerHeight, $(window).height()):$(window).height();
					$('.nav__menu-collapse').height(winHeight);
				});

				var galleryElems = document.querySelectorAll('.carousel-events');

				for ( var i=0, len = galleryElems.length; i < len; i++ ) {
				var galleryElem = galleryElems[i];
					new Flickity( galleryElem, {
						cellAlign: 'left',
						pageDots: false
					});
				}

				var casesElems = document.querySelectorAll('.carousel-cases');

				for ( var i=0, len = casesElems.length; i < len; i++ ) {
				var casesElem = casesElems[i];
					new Flickity( casesElem, {
						cellAlign: 'left',
						pageDots: false
					});
				}

				// Validatie email Gform
				$('.ginput_container_email input').on('keyup', function(e){
					var text 	= $(this).val();
					var regex 	= /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
					if(regex.test(text)){
						$(this).parents('.mailvalidation').addClass('validated');
					}else{
						$(this).parents('.mailvalidation').removeClass('validated');
					}
				});


				// Mixitup voor projecten
				var $containerMixitup = document.querySelector('[data-mixitup]');
				if ($containerMixitup) {
					var initialFilter = 'all';
					var hash = window.location.hash.replace(/^#/g, '');

					if (hash) {
						initialFilter = '.' + hash;
					}

					var mixer = mixitup($containerMixitup, {
						load: {
							filter: initialFilter
						}
					});
				}


        	    // Code om functies werkend te krijgen binnen de overlays.
        	    $('body').on('bless', function(){
	        	    var mySVGsToInject = document.querySelectorAll('img.inject');
					new SVGInjector(mySVGsToInject);

					new Clipboard('.btn-cb');


			  		new Tippy('.tippy', {
					    position: 'top',
					    animation: 'fade',
					    duration: 300,
					    arrow: true,
					    theme: 'au'
					});

					$('.tippy').on('click', function(){
						$('body').addClass('overlay__notice--active');
						console.log('copied!');

						setTimeout(function(){
							$('body').removeClass('overlay__notice--active');
						}, 3000);
					});


			  		objectFitImages('img.img--objectfit');


					function new_map( $el ) {
				    	var $markers = $el.find('.marker');

				    	var args = {
				    		zoom					: 12,
				    		center					: new google.maps.LatLng(0, 0),
				    		mapTypeId				: google.maps.MapTypeId.ROADMAP,
				    		disableDefaultUI		: true,
				    		scrollwheel				: false,
				    		draggable				: false,
				    		zoomControl				: false,
				    		disableDoubleClickZoom	: false,
				    		styles 			: [
							    {
							        "featureType": "administrative",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "off"
							            }
							        ]
							    },
							    {
							        "featureType": "landscape",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "simplified"
							            },
							            {
							                "hue": "#0066ff"
							            },
							            {
							                "saturation": 74
							            },
							            {
							                "lightness": 100
							            }
							        ]
							    },
							    {
							        "featureType": "poi",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "simplified"
							            }
							        ]
							    },
							    {
							        "featureType": "road",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "simplified"
							            }
							        ]
							    },
							    {
							        "featureType": "road.highway",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "off"
							            },
							            {
							                "weight": 0.6
							            },
							            {
							                "saturation": -85
							            },
							            {
							                "lightness": 61
							            }
							        ]
							    },
							    {
							        "featureType": "road.highway",
							        "elementType": "geometry",
							        "stylers": [
							            {
							                "visibility": "on"
							            }
							        ]
							    },
							    {
							        "featureType": "road.arterial",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "off"
							            }
							        ]
							    },
							    {
							        "featureType": "road.local",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "on"
							            }
							        ]
							    },
							    {
							        "featureType": "transit",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "simplified"
							            }
							        ]
							    },
							    {
							        "featureType": "water",
							        "elementType": "all",
							        "stylers": [
							            {
							                "visibility": "simplified"
							            },
							            {
							                "color": "#5f94ff"
							            },
							            {
							                "lightness": 26
							            },
							            {
							                "gamma": 5.86
							            }
							        ]
							    }
							]
				    	};

				    	var map = new google.maps.Map( $el[0], args);

				    	// add a markers reference
				    	map.markers = [];

				    	// add markers
				    	$markers.each(function(){
				        	add_marker( $(this), map );
				    	});

				    	center_map( map );

				    	return map;
				    }

				    // This function will add a marker to the selected Google Map
				    function add_marker( $marker, map ) {
				    	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

						var iconBase = '../../app/themes/stipo/dist/images/';

				    	var marker = new google.maps.Marker({
							position	: latlng,
							map			: map,
							label: {
								text: "STIPO",
								color: "#3693A0",
								fontSize: "14px",
								fontWeight: "regular"
							},
				    		icon 		: {
								labelOrigin: new google.maps.Point(45, 15),
					    		url 		: iconBase + 'iconmarker.svg',
					    		scaledSize 	: new google.maps.Size(20, 27)
							},
							title		: "STIPO",
							visible		: true
						});

				    	// add to array
				    	map.markers.push( marker );

				    	// if marker contains HTML, add it to an infoWindow
				    	if( $marker.html() ) {
				    		// create info window
				    		var infowindow = new google.maps.InfoWindow({
				    			content		: $marker.html()
				    		});

				    		// show info window when marker is clicked
				    		google.maps.event.addListener(marker, 'click', function() {
				    			infowindow.open( map, marker );
				    		});
				    	}
				    }


				    // This function will center the map, showing all markers attached to this map
				    function center_map( map ) {
				    	var bounds = new google.maps.LatLngBounds();

				    	// loop through all markers and create bounds
				    	$.each( map.markers, function( i, marker ){
				    		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

				    		bounds.extend( latlng );
				    	});

				    	// only 1 marker?
				    	if( map.markers.length == 1 ){
				    	    map.setCenter( bounds.getCenter() );
				    	    map.setZoom( 12 );
				    	}
				    	else{
				    		map.fitBounds( bounds );
				    	}
				    }


				    // This function will render each map when the document is ready (page has loaded)
				    var map = null;

				    $(document).ready(function(){
				    	$('.acf-map').each(function(){
				    		map = new_map( $(this) );
				    	});
				    });

        	    });


    	    	$('body').trigger('bless');


			},
			finalize: function() {
			    // JavaScript to be fired on the home page, after the init JS
			}

		},
		'dummy': {
			init: function() {

			    if (viewportWidth > 767) {
				    // Dummy items creeren om lege ruimte tussen items op te lossen i.v.m. flexbox space-between, zie cleanup.php voor functie bodyclass.
				    function checkCount(current_total, next){
				      	if(current_total % 4){
				        	current_total += 1;
				        	checkCount(current_total, next); // Recursion!
				      	} else {
				        	next(current_total);
				      	}
				    }
				    function addDummyItemToItems($items){
				      	var container 	= $items[0];
				      	var card_count 	= container.children.length;
				      	checkCount(card_count, function(final_count){
				    	    var dummy_element;
				    	    for(let i=0; i<(final_count-card_count); i++){
				    	      	dummy_element 			= document.createElement('div');
				    	      	dummy_element.className = 'item--dummy';
				    	      	container.appendChild(dummy_element);
				    	    }
				      	});
				    }

				    $('.items--default').each(function() {
						addDummyItemToItems($(this));
						console.log('dummy');
				    });
				}

			},
			finalize: function() {

			}
		},
		'dummy_alumni': {
			init: function() {

				if (viewportWidth > 767) {
				    // Dummy items creeren om lege ruimte tussen items op te lossen i.v.m. flexbox space-between, zie cleanup.php voor functie bodyclass.
				    function checkCount(current_total, next){
				      	if(current_total % 5){
				        	current_total += 1;
				        	checkCount(current_total, next); // Recursion!
				      	} else {
				        	next(current_total);
				      	}
				    }
				    function addDummyItemToItems($items){
				      	var container 	= $items[0];
				      	var card_count 	= container.children.length;
				      	checkCount(card_count, function(final_count){
				    	    var dummy_element;
				    	    for(let i=0; i<(final_count-card_count); i++){
				    	      	dummy_element 			= document.createElement('div');
				    	      	dummy_element.className = 'item--dummy-alumni';
				    	      	container.appendChild(dummy_element);
				    	    }
				      	});
				    }

				    $('.items--alumni').each(function() {
				    	addDummyItemToItems($(this));
				    });
			   	}

			},
			finalize: function() {

			}
		},
		'dummy_academie': {
			init: function() {

				if (viewportWidth > 767) {
				    // Dummy items creeren om lege ruimte tussen items op te lossen i.v.m. flexbox space-between, zie cleanup.php voor functie bodyclass.
				    function checkCount(current_total, next){
				      	if(current_total % 3){
				        	current_total += 1;
				        	checkCount(current_total, next); // Recursion!
				      	} else {
				        	next(current_total);
				      	}
				    }
				    function addDummyItemToItems($items){
				      	var container 	= $items[0];
				      	var card_count 	= container.children.length;
				      	checkCount(card_count, function(final_count){
				    	    var dummy_element;
				    	    for(let i=0; i<(final_count-card_count); i++){
				    	      	dummy_element 			= document.createElement('div');
				    	      	dummy_element.className = 'item--dummy-academie';
				    	      	container.appendChild(dummy_element);
				    	    }
				      	});
				    }

				    $('.items--academie').each(function() {
				    	addDummyItemToItems($(this));
				    });
			   	}

			},
			finalize: function() {

			}
		}

	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Starter;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
		// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

  	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
